import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { Document, Page } from 'react-pdf';
import ReactPlayer from 'react-player';
import closeIcon from '../../../../assets/images/close-icon-02.png'

type IProps = {
  handleCloseEvent?: () => void;
  url: string;
  type?: string;
  title?: string;
};

const VideoScreen = (props: IProps) => {
  const playerRef = useRef<ReactPlayer>(null);
  const [extension, setExtension] = useState<any>('');
  const [playingStatus, setPlayingStatus] = useState<boolean>(true);
  const [numPages, setNumPages] = useState(null);
  const [isIOS, setIsIOS] = useState(false);
  const [unmuted, setUnmuted] = useState(false);
  const unmuteTimeoutsRef = useRef<NodeJS.Timeout[]>([]);

  useEffect(() => {
    const ios = /iPad|iPhone|iPod/.test(navigator.userAgent);
    setIsIOS(ios);
  }, []);

  useEffect(() => {
    if (!isIOS) return; 
    if (unmuted) return;

    const attemptUnmute = () => {
      const video = playerRef.current?.getInternalPlayer() as HTMLVideoElement | null;
      if (video && !unmuted) {
        try {
          video.muted = false;
          
          if (!video.muted) {
            setUnmuted(true);
            unmuteTimeoutsRef.current.forEach(t => clearTimeout(t));
            unmuteTimeoutsRef.current = [];
            console.log('iOS auto-unmute successful');
            return true;
          }
        } catch (error) {
          console.error('iOS auto-unmute failed:', error);
        }
      }
      return false;
    };

    const delays = [50, 100, 200, 300, 500, 800, 1000, 1500, 2000];
    
    delays.forEach(delay => {
      const timeout = setTimeout(attemptUnmute, delay);
      unmuteTimeoutsRef.current.push(timeout);
    });

    return () => {
      unmuteTimeoutsRef.current.forEach(t => clearTimeout(t));
      unmuteTimeoutsRef.current = [];
    };
  }, [isIOS, unmuted, props.url]);

  useEffect(() => {
    if (!isIOS) return; 
    if (unmuted) return;

    const enableAudio = () => {
      const video = playerRef.current?.getInternalPlayer() as HTMLVideoElement | null;
      if (video && !unmuted) {
        video.muted = false;
        if (!video.muted) {
          setUnmuted(true);
          console.log('iOS unmuted via user interaction');
        }
      }
    };

    const events = ['touchstart', 'touchend', 'click', 'mousedown'];
    
    events.forEach(event => {
      document.addEventListener(event, enableAudio, { once: true, passive: true });
    });

    return () => {
      events.forEach(event => {
        document.removeEventListener(event, enableAudio);
      });
    };
  }, [isIOS, unmuted]);

  const handlePlay = () => {
    if (!isIOS) return; 
    if (unmuted) return;

    setTimeout(() => {
      const video = playerRef.current?.getInternalPlayer() as HTMLVideoElement | null;
      if (video && !unmuted) {
        video.muted = false;
        if (!video.muted) {
          setUnmuted(true);
          console.log('iOS unmuted on play event');
        }
      }
    }, 50);
  };

  useEffect(() => {
    if (!isIOS) return; 
    if (unmuted) return;

    const handleVisibilityChange = () => {
      if (!document.hidden && !unmuted) {
        setTimeout(() => {
          const video = playerRef.current?.getInternalPlayer() as HTMLVideoElement | null;
          if (video && !unmuted) {
            video.muted = false;
            if (!video.muted) {
              setUnmuted(true);
              console.log('iOS unmuted on visibility change');
            }
          }
        }, 100);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isIOS, unmuted]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  function getLastWordAfterDot(inputString) {
    const parts = inputString?.split('.');
    const lastWord = parts[parts.length - 1];
    return "." + lastWord;
  }

  useEffect(() => {
    let url = props?.url;
    console.log(getLastWordAfterDot(url), "getLastWordAfterDot(url)")
    setExtension(getLastWordAfterDot(url))
  }, [props?.url]);

  return (
    <>
      <div id="video_screen_id" className="center_container marginPadding_zero">
        <div className="VideoTitle row relative">
          <div className="col-9 " style={{ marginTop: '-50px' }}>
            <div className="VideoTitleText">
              <span>Activity: </span>
              <span>{props.type ? props.type : "NA"}</span>
            </div>
            <div className="VideoTitleText">
              <span>Title:</span>
              <span> {props.title ? props.title : "NA"}</span>
            </div>
          </div>
          {/* {props.handleCloseEvent && <div className="VideoTitleCloseBtn col-3" style={{ marginTop: '-50px' }}>
            <button className="absolute right-0 top-16 -translate-y-1/2 mobile:left-4 tablet:-right-10 laptop:right-12 desktop:-right-0 z-10" onClick={() => props.handleCloseEvent()}>
              <img height={16} width={24} src={closeIcon} alt="" />
            </button>
          </div>} */}

          <div
            className="col-12"
            style={{
              height: 'calc(100vh)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {extension === '.pdf' ? (
              <div className=' w-100' style={{ height: 'calc(60vh)', overflowX: 'hidden' }}>
                <Document file={props?.url} onLoadSuccess={onDocumentLoadSuccess}>
                  {Array.from(new Array(numPages), (el, index) => (
                    <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                  ))}
                </Document>
              </div>
            ) : [
              '.dotx',
              '.dot',
              '.doc',
              '.docm',
              '.docx',
              '.xlsx',
              '.txt',
              '.xla',
              '.xlam',
              '.xll',
              '.xlm',
              '.xls',
              '.xlsm',
              '.xlt',
              '.xltm',
              '.xltx',
              '.xps',
              '.pot',
              '.potm',
              '.potx',
              '.ppam',
              '.pps',
              '.ppsm',
              '.ppsx',
              '.ppt',
              '.pptm',
              '.pptx',
              '.sldm',
              '.sldx',
            ].includes(extension) ? (
              <iframe
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${props?.url}`}
                width="100%"
                height="330px"
              ></iframe>
            ) : (
              <ReactPlayer
                ref={playerRef}
                url={props?.url}
                playing={true}
                muted={isIOS && !unmuted}  
                playsinline={true}
                controls={false}
                width="100%"
                height="100%"
                style={{ pointerEvents: "none" }}
                config={{
                  file: {
                    attributes: {
                      playsInline: true,
                    },
                  },
                }}
                onPlay={handlePlay}  
                onPause={() => { }}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default VideoScreen;